import styled from 'styled-components'

const BaseContainer = styled.div<{
  width?: string
  col?: boolean
  alignItems?: string
  justifyContent?: string
  gap?: string
  spWidth?: string
}>`
  display: flex;
  flex-direction: ${(p) => (p.col ? 'column' : 'row')};
  align-items: ${(p) => p.alignItems || 'center'};
  justify-content: ${(p) => p.justifyContent || 'flex-start'};
  gap: ${(p) => p.gap || p.theme.space.m};
  width: ${(p) => p.width || '100%'};

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    width: ${(p) => p.spWidth || p.width || '100%'};
  }
`

const BaseContent = styled.div<{ width?: string; maxWidth?: string }>`
  width: ${(p) => p.width || '100%'};
  max-width: ${(p) => p.maxWidth || 'none'};
`

export { BaseContainer, BaseContent }
